/**
 * 页面背景 style.backgroundSize，与 Picture / Carousel 同一套历史契约：
 * - contain（缺省）= UI「铺满」→ 拉伸铺满（CSS background-size: 100% 100%）
 * - 100% 100%     = UI「等比例缩放」→ 完整显示（CSS background-size: contain）
 * 老工程无字段 → 按铺满处理，与改前始终拉伸行为一致。
 */

export function normalizeBackBackgroundSize(raw) {
  return raw === "100% 100%" ? "100% 100%" : "contain";
}

/** 是否「铺满」拉伸（含缺省） */
export function isBackBackgroundFill(raw) {
  return normalizeBackBackgroundSize(raw) === "contain";
}

/** 编辑器 / 预览用的 CSS background-size */
export function backBackgroundCssSize(raw) {
  return isBackBackgroundFill(raw) ? "100% 100%" : "contain";
}
